import Component from '../colorz/Component';

export default class AnchorEnvironment extends Component {
	onInit(el) {
		this.el = el;
	}

	onLoad() {
		if (
			window.location.hash === '#fiche-environnementale' ||
			window.location.hash === '#ficha-medioambiental'
		) {
			this.goToDropdown();
		}
	}

	goToDropdown() {
		this.elExpandBtn = this.el.querySelector('.c-expandable__btn');
		this.elExpand = this.el.querySelector('.c-expandable');

		if (!this.elExpandBtn || !this.elExpand) {
			return console.error('AnchorEnvironment: missing elements');
		}

		this.elExpandBtn.classList.add('is-open');
		this.elExpandBtn.setAttribute('aria-expanded', 'true');
		this.elExpand.classList.add('is-open');

		this.el.scrollIntoView({
			behavior: 'smooth',
			block: 'start',
		});
	}
}
